import mutationsTypes from '@/vuex/juntada/mutations-types.js'
const types = {
  ...mutationsTypes,
  GET_DOCUMENTO_SELECIONADO: 'GET_DOCUMENTO_SELECIONADO',
  GET_LISTA_DOCUMENTOS: 'GET_LISTA_DOCUMENTOS',
  JUNTAR_DOCUMENTOS: 'JUNTAR_DOCUMENTOS'
}

export default types
